import React from "react";
function Separator() {
  return <div className=" my-4 rounded-full h-2 w-3/5 bg-orange-700"></div>;
}

export default Separator;